import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import cx from "classnames";
import styles from "../scss/DapNoRecommendations.module.scss";
import Icon from "../../common/components/Icon/Icon";
import { SplitTreatments } from "@splitsoftware/splitio-react";
import ProgressBar from "../../common/components/ProgressBar/ProgressBar";
import { FeatureFlag } from "../../compare/enums/FeatureFlags";
import HelpSection from "../../common/components/HelpSection/HelpSection";
import {
    callbackDetails
} from "../api/ApiDigitalAdvice";
import { AdviceControllerContext } from "../providers/DigitalAdviceProvider";
import useErrorLogger from "../../common/hooks/useErrorLogger";
import NoRecommendationDetailsForm from "../components/NoRecommendationDetailsForm";
import { IContactDetails } from "../interfaces/IContactDetails";

const NoRecommendations: React.FC = () => {
    const history = useHistory();

    const handleBack = (): void => {
        history.goBack();
    };

    const { selectors } = useContext(AdviceControllerContext);

    const [progressBarCurrentStage, setProgressBarCurrentStage] = useState<
        React.ComponentProps<typeof ProgressBar>["progressBarCurrentStage"]
    >("advice");

    const progressBarStages: React.ComponentProps<
        typeof ProgressBar
    >["progressBarStages"] = [
        {
            sectionTitle: "Why care?",
            sectionTitleMobile: "Why",
            id: "why"
        },
        {
            sectionTitle: "You & your family",
            sectionTitleMobile: "You",
            id: "you"
        },
        {
            sectionTitle: "Your finances",
            sectionTitleMobile: "Finances",
            id: "finances"
        },
        {
            sectionTitle: "Our Advice",
            sectionTitleMobile: "Advice",
            id: "advice"
        }
    ];

    const handleSubmitContactDetails = (
        newContactDetails: IContactDetails
    ): Promise<boolean> => {
        history.push(`/digital-advice`);

        return callbackDetails({
            sessionUserId: selectors.getSessionUserId(),
            visitorId: selectors.getVisitorId(),
            ...newContactDetails
        });
    };

    useEffect(() => {
        abTesting.convertAll(17, "", "", 0);
    }, []);

    return (
        <React.Fragment>
            <ProgressBar
                progressBarCurrentStage={progressBarCurrentStage}
                progressBarStages={progressBarStages}
            />
            <div className={styles["layout"]}>
                <div className={cx(styles["no-recommend"])}>
                    <button
                        className={styles["back-btn"]}
                        onClick={() => {
                            handleBack();
                        }}>
                        <Icon
                            size="l"
                            className={cx(styles.icon)}
                            id="ChevronBackLarge"
                        />
                        Back
                    </button>
                    <div className={cx([styles["no-recommend-wrapper"]])}>
                        <label className={styles["no-recommend-title"]}>
                            We cannot offer you a recommendation at this time.
                        </label>

                        <p className={styles["no-recommend-subtitle"]}>
                            Your situation is unique and one of our adviser team would
                            love to work it through with you. We just need a few more
                            details so our advisors can help with this.
                        </p>

                        <NoRecommendationDetailsForm
                            onSubmit={handleSubmitContactDetails}
                            className={cx([styles["no-recommend-form"]])}
                        />
                    </div>
                </div>

                <HelpSection
                    title="Need help to choose?"
                    subtext="Talk to us today! A friendly LifeDirect Specialist can answer questions and help you choose an insurer."
                />
            </div>
        </React.Fragment>
    );
};

export default NoRecommendations;
